import type { Placement } from 'components/modals/constants';
import type Theme from 'style/types/theme';
import styled from 'styled-components';

import style from '../../../../../style';

interface WrapperProps {
  $placement: Placement;
  theme: Theme;
}

export const Wrapper = styled.div<WrapperProps>(({ theme: { color }, $placement }) => ({
  display: 'flex',
  justifyContent: $placement,
  alignItems: 'center',
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 10000,
  width: '100%',
  height: '100%',
  backgroundColor: color.background.reversed.default(0.5),

  ...style.mixins.responsive.sm.downward({
    alignItems: 'end',
  }),
}));
